import { UntypedFormBuilder, Validators } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";


export interface PortalUser {
    userName: string;
    email: string;
    phoneNumber: string;
    createdBy?: string;
    id?: string;
    password?: string;
    normalizedEmail?: string;
    normalizedUserName?: string;
    emailConfirmed?: boolean;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | null;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    isEnabled: boolean;
    name: string;
    surname: string;
    timestamp?: string;
    isLockedOut?:boolean;
    initials?:string;
}
  
export class PortalUserFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, portalUser: PortalUser) {
  
      return fb.group(
        {
          id: [portalUser.id],
          userName: [portalUser.userName,[Validators.required, Validators.minLength(6), Validators.pattern("^[a-zA-Z-]+$")]],
          name: [portalUser.name,[Validators.required, Validators.min(1)]],
          surname: [portalUser.surname, [Validators.required, Validators.min(1)]],
          phoneNumber: [portalUser.phoneNumber, [Validators.required,Validators.pattern("^[0-9- ]+$")]],
          email: [portalUser.email, [Validators.required,Validators.email]]
        }
      );
    }
  
    static initPortalUser() : PortalUser {
      return{
        id:'',
        userName:'',
        name:'',
        surname:'',
        email:'',
        phoneNumber:'',
        isEnabled: true
      };
    }
  }